export const convertPrice = function convertPrice(priceStr) {
	if (typeof priceStr !== 'number' && typeof priceStr !== 'string') {
		return priceStr;
	}

	if (!/^[0-9.,-]+$/.test(priceStr.toString())) {
		return priceStr;
	}

	if (/,-$/.test(priceStr.toString())) {
		return priceStr;
	}

	priceStr = priceStr.toString();

	let validPrice =
		!priceStr.includes('.') && !priceStr.includes(',')
			? priceStr + ',-'
			: Number(priceStr.replace(',', '.')).toFixed(2);
	validPrice = ('' + validPrice).replace('.', ',').replace(',00', ',-');

	return validPrice;
};

export const applyTags = (textToConvert, boldClassName = 'bold') => {
	if (!textToConvert) {
		return '';
	}

	let result = textToConvert;

	if (typeof textToConvert != 'undefined') {
		result = textToConvert
			.replace(/\{\{n\}\}/gi, '<br/>')
			.replace(/{n}/gi, '<br/>')
			.replace(/{b}/gi, '<b class="' + boldClassName + '">')
			.replace(/{\/b}/gi, '</b>');
	}

	return result;
};
